var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner", attrs: { id: "tab-hawb" } },
    [
      _c("common-hawb", {
        ref: "hawb",
        attrs: {
          job: _vm.job,
          form: _vm.form,
          action: _vm.action,
          context: _vm.context,
          "cooperate-edit": _vm.cooperateEdit
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }